<div id="enroll-sms-mfa" class="mx-auto flex flex-column align-content-center align-items-center gap-4">
  <h2 i18n>Enroll SMS MFA</h2>
  <form *ngIf="showMobileInput" (ngSubmit)="submitMobileNumber()" class="flex flex-column gap-2">
    <p i18n>Please enter your mobile number</p>
    <input id="mobileNumber" [(ngModel)]="mobileNumber" name="mobileNumber" required class="px-3 py-3" />
    <button class="p-button form-btn" type="submit" i18n>Send SMS Code</button>
  </form>
  <div *ngIf="smsSent" class="flex flex-column gap-2">
    <p i18n>Enter the code sent to your mobile number</p>
    <input id="sms-code" [(ngModel)]="form.code" name="smsCode" maxlength="6" class="px-3 py-3" />
    <button class="p-button form-btn" type="button" (click)="verifySmsCode()" (keydown)="verifySmsCode()" i18n>Verify</button>
    <p-message *ngIf="form.errors.code === 'INVALID_CODE'" styleClass="mb-3" severity="error" i18n>Invalid code. Please try again.</p-message>
    <p-message *ngIf="success" styleClass="mb-3" severity="success" i18n>Code confirmed!</p-message>
  </div>
</div>
